import i18next from 'i18next'

export default {
  getValidationOptions() {
    return {
      notImplemented: {
        id: 'notImplemented',
        text: i18next.t('common.not_implemented'),
      },
      implemented: {
        id: 'implemented',
        text: i18next.t('common.implemented'),
      },
      impactNotValidated: {
        id: 'impactNotValidated',
        text: i18next.t('common.impact_not_validated'),
      },
      impactValidated: {
        id: 'impactValidated',
        text: i18next.t('common.validated_impact'),
      },
    }
  },
}
